import { useIntl } from 'react-intl'
import { connect } from 'react-redux'

import type { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import {
  bnblSwitchablePackageDurations,
} from 'components/OfferPage/BnblModal/utils'
import BnblSwitchPackageDurationItem from './BnblSwitchPackageDurationItem'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface MappedProps {
  numberOfRooms: number
  packageView: App.OfferPackageOptionView
}

interface Props {
  offer: App.HotelOffer
  setStep: (step: BnblSteps) => void
  selectedPackageUniqueKey: string
  setSelectedPackageUniqueKey: (uniqueKey: string) => void
  isGift: boolean
}

function BnblSwitchPackageDurationStep({
  numberOfRooms,
  offer,
  packageView,
  selectedPackageUniqueKey,
  setSelectedPackageUniqueKey,
  isGift,
}: Props & MappedProps) {
  const intl = useIntl()
  // get all possible "switchable" package durations
  const switchablePackageDurations = bnblSwitchablePackageDurations(offer, packageView.package)

  const onSwitchPackageDuration = (newPackageUniqueKey: string) => {
    setSelectedPackageUniqueKey(newPackageUniqueKey)
  }

  return (
    <VerticalSpacer gap={32}>
      <BodyText variant="large">{intl.formatMessage({
        id: 'AGVdxRjcfP__Op_PugEA',
        defaultMessage: 'This offer is available for the following lengths of stay:',
        description: 'Body text introducing duration options in BNBL switch duration step',
      })}
      </BodyText>
      <div>
        {switchablePackageDurations.map(switchablePackage => {
          const {
            bonusInclusions,
            duration,
            price: packagePrice,
            memberPrice: packageMemberPrice,
            propertyFees,
            uniqueKey,
          } = switchablePackage.package

          const hasMemberPrice = !isGift && packageMemberPrice > 0
          const price = hasMemberPrice ? packageMemberPrice : packagePrice
          const pricePerRoom = price + propertyFees
          const totalPrice = pricePerRoom * numberOfRooms

          return (
            <BnblSwitchPackageDurationItem
              key={uniqueKey}
              bonusInclusions={!!bonusInclusions.length}
              checked={uniqueKey === selectedPackageUniqueKey}
              name={duration}
              nights={duration}
              onSwitchPackageDuration={() => onSwitchPackageDuration(uniqueKey)}
              price={totalPrice}
              hasMemberPrice={hasMemberPrice}
            />
          )
        })}
      </div>
    </VerticalSpacer>
  )
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  const bnblModalPackages = state.offer.bnblModal[ownProps.offer.id]
  const { numberOfRooms, packageView } = bnblModalPackages[0]

  return {
    numberOfRooms,
    packageView,
  }
}

export default connect(mapStateToProps)(BnblSwitchPackageDurationStep)
